import { getQueryMethod, resources, entities, methods, getURLParams } from '../utils';
const { meloAPI } = resources;
const { products } = entities;
const { POST, PATCH, DELETE } = methods;

const query = getQueryMethod(meloAPI, products);

const endpoints = {
  createProduct: async (businessId, productData) => {
    return await query('', POST, { businessId, ...productData });
  },
  getProductsPaginated: async ({ businessId, ...params }) => {
    const queryParams = getURLParams(params);
    return await query(`${businessId}?${queryParams}`);
  },
  getProduct: async (businessId, productId) => {
    return await query(`${businessId}/${productId}`);
  },
  getSupplierByIdentification: async (businessId, identificationNumber) => {
    return await query(`${businessId}/${identificationNumber}/by-identification`);
  },
  updateProducts: async (businessId, productId, productData) => {
    return await query(`${businessId}/${productId}`, PATCH, productData);
  },
  getAllProducts: async businessId => {
    return await query(`${businessId}/by/all`);
  },
  deleteProducts: async (businessId, productsIds) => {
    return await query(`${businessId}/delete/many`, PATCH, productsIds);
  },
};

export default endpoints;
